import axios from 'axios';

const BASE_URL = 'https://api1.ebetlab.com';
axios.interceptors.request.use(
    function (config) {
        const bearer = localStorage.getItem('bearer');
        config.headers.Authorization = `Bearer ${bearer}`;
        // config.headers['W-SECRET'] = process.env.REACT_APP_WEBSITE_SECRET; // GAMBI.COM
        config.headers['W-SECRET'] = localStorage.getItem('w-secret'); // GAMBI.COM
        config.headers['x-api-auth'] = 'EBTLB_BASE_VAR'; // 🔐 secure token

        config.baseURL = `${BASE_URL}/api/player/`;
        return config;
    },
    function (error) {
        // Do something with request error
        return Promise.reject(error);
    }
);


export default {
    post: (url, body, additionalHeaders = {}) => axios.post(url, body, {
        headers: {
            ...additionalHeaders // Merge additional headers with default headers
        },
        // withCredentials: true
    })
        .then(response => response.data)
        .catch(error => {

            console.log('errr = ', error)

            // if (error.response?.data?.error === "Missing signed cookie") {
            //
            //     associateServices.getCookie({}).then(res => {
            //
            //     })
            // }

            return error.response?.data
        }),

    get: (url) => axios.get(url)
        .then(response => response.data)
        .catch(error => error.response?.data),

    setHeader: (key, value) => axios.interceptors.request.use(
        function (config) {
            config.headers[key] = value;
            config.baseURL = `${BASE_URL}/api/player/`;
            return config;
        }
    )
};
